// extracted by mini-css-extract-plugin
export default {"posts":"home_posts__iI38q"};